import { BreachEvent, BreachEventProps } from '@news-mono/web-common'
import { DataLayerEventName } from '@news-mono/web-common'

export function createLinkClickEvent(
    creative: string,
    deal: string,
    onEvent: (event: BreachEvent) => void,
    breachScreenType: BreachEventProps['breachScreenType'] = 'Premium - Inline',
    leadDepth?: number,
): () => void {
    const eventPayload: BreachEvent['payload'] = {
        paywallType: 'freemium',
        leadDepth: leadDepth ?? 0,
        creative: creative,
        breachScreenType,
        popupMethod: 'auto',
        deal: deal,
        pricepoint: [7, 8],
    }

    return () => {
        onEvent({
            type: DataLayerEventName.breachScreenClick,
            originator: 'breachscreen',
            payload: eventPayload,
        })
    }
}
